// extracted by mini-css-extract-plugin
module.exports = {"PostcodeAutocomplete":"PostcodeAutocomplete_PostcodeAutocomplete__w55Fi","FloatingLabel":"PostcodeAutocomplete_FloatingLabel__HSu4Y","-show":"PostcodeAutocomplete_-show__8NriD"};